export default "__VITE_ASSET__C8U$nfnM__ 320w, __VITE_ASSET__CuS$cwow__ 480w, __VITE_ASSET__CObVEeQ7__ 640w, __VITE_ASSET__D407mcXE__ 800w";